import React                    from 'react';
/*import ArticleHeadline          from './ArticleHeadline.jsx';
import ArticleFooter            from './ArticleFooter.jsx';
import ArticleSocialVertical    from './ArticleSocialVertical.jsx';
import ArticleSocialHorizontal  from './ArticleSocialHorizontal.jsx';
import ArticleAuthor            from './ArticleAuthor.jsx';*/

export default class Article extends React.Component {

    componentDidMount () {
        try {
            espn_ui.LoadBehavior(jQuery('#article-feed'));
        } catch (e) {
            console.log(e);
        }
    }
	
	render () {
        return (
            <div id="article-feed" data-module="article">
                <div data-behavior="author_overlay article_header_news_feed_item_meta social_tools comment" dangerouslySetInnerHTML={{ __html: this.props.article.html }}>
                </div>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/article/index.jsx
 **/